module.exports = __webpack_public_path__ + "static/media/aed9ac10.jpg";